<template>
  <div class="talent">
    <div class="bg">
      <img src="../../assets/image/talent/banner.png" alt="" />
    </div>
    <div class="looking-for">
      <h2 class="title">{{ $t("recruitment.looking") }}</h2>
      <div>
        <el-tabs
          v-model="activeName"
          type="card"
          stretch
          active-text-color="#ff0404"
        >
          <el-tab-pane :label="java()" name="first">
            <div class="you">
              <div class="looking-left">
                <span>【{{ $t("recruitment.java_engineer.jobs") }}】</span>
                <div>1、{{ $t("recruitment.java_engineer.duties") }}</div>
                <div>2、{{ $t("recruitment.java_engineer.duties2") }}</div>
                <div>3、{{ $t("recruitment.java_engineer.duties3") }}</div>
                <div>4、{{ $t("recruitment.java_engineer.duties4") }}</div>
                <div>5、{{ $t("recruitment.java_engineer.duties5") }}</div>
              </div>
              <div class="looking-right">
                <span>【{{ $t("recruitment.java_engineer.require") }}】</span>
                <div>1、{{ $t("recruitment.java_engineer.require_details") }}</div>
                <div>
                  2、{{ $t("recruitment.java_engineer.require_details2") }}
                </div>
                <div>
                  3、{{ $t("recruitment.java_engineer.require_details3") }}
                </div>
                <div>4、{{ $t("recruitment.java_engineer.require_details4") }}</div>
                <div>5、{{ $t("recruitment.java_engineer.require_details5") }}</div>
                <div>
                  6、{{ $t("recruitment.java_engineer.require_details6") }}
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="project()">
            <div class="you">
              <div class="looking-left">
                <span>【{{ $t("recruitment.java_engineer.jobs") }}】</span>
                <div>
                  1、{{ $t("recruitment.project_engineer.duties") }}
                </div>
                <div>
                  2、{{ $t("recruitment.project_engineer.duties2") }}
                </div>
                <div>
                  3、{{ $t("recruitment.project_engineer.duties3") }}
                </div>
                <div>
                  4、{{ $t("recruitment.project_engineer.duties4") }}
                </div>
                <div>
                  5、{{ $t("recruitment.project_engineer.duties5") }}
                </div>
              </div>
              <div class="looking-right">
                <span>【{{ $t("recruitment.java_engineer.require") }}】</span>
                <div>1、{{ $t("recruitment.project_engineer.require_details") }}</div>
                <div>2、{{ $t("recruitment.project_engineer.require_details2") }}</div>
                <div>
                  3、{{ $t("recruitment.project_engineer.require_details3") }}
                </div>
                <div>
                  4、{{ $t("recruitment.project_engineer.require_details4") }}
                </div>
                <div>
                  5、{{ $t("recruitment.project_engineer.require_details5") }}
                </div>
                <div>6、{{ $t("recruitment.project_engineer.require_details6") }}</div>
                <div>7、{{ $t("recruitment.project_engineer.require_details7") }}</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="product()">
            <div class="you">
              <div class="looking-left">
                <span>【{{ $t("recruitment.java_engineer.jobs") }}】</span>
                <div>
                  1、{{ $t("recruitment.product_manager.duties") }}
                </div>
                <div>
                  2、{{ $t("recruitment.product_manager.duties2") }}
                </div>
                <div>
                  3、{{ $t("recruitment.product_manager.duties3") }}
                </div>
                <div>
                  4、{{ $t("recruitment.product_manager.duties4") }}
                </div>
                <div>5、{{ $t("recruitment.product_manager.duties5") }}</div>
              </div>
              <div class="looking-right">
                <span>【{{ $t("recruitment.java_engineer.require") }}】</span>
                <div>
                  1、{{ $t("recruitment.product_manager.require_details") }}
                </div>
                <div>
                  2、{{ $t("recruitment.product_manager.require_details2") }}
                </div>
                <div>
                  3、{{ $t("recruitment.product_manager.require_details3") }}
                </div>
                <div>
                  4、{{ $t("recruitment.product_manager.require_details4") }}
                </div>
                <div>
                  5、{{ $t("recruitment.product_manager.require_details5") }}
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="assistant()">
            <div class="you">
              <div class="looking-left">
                <span>【{{ $t("recruitment.java_engineer.jobs") }}】</span>
                <div>
                  1、{{ $t("recruitment.product_assistant.duties") }}
                </div>
                <div>
                  2、
                  {{ $t("recruitment.product_assistant.duties") }}
                </div>
                <div>
                  3、{{ $t("recruitment.product_assistant.duties") }}
                </div>
              </div>
              <div class="looking-right">
                <span>【{{ $t("recruitment.java_engineer.require") }}】</span>
                <div>1、{{ $t("recruitment.product_assistant.require_details") }}</div>
                <div>2、{{ $t("recruitment.product_assistant.require_details2") }}</div>
                <div>
                  3、{{ $t("recruitment.product_assistant.require_details3") }}
                </div>
                <div>
                  4、{{ $t("recruitment.product_assistant.require_details4") }}
                </div>
                <div>5、{{ $t("recruitment.product_assistant.require_details5") }}</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="manager()">
            <div class="you">
              <div class="looking-left">
                <span>【{{ $t("recruitment.java_engineer.jobs") }}】</span>
                <div>
                  1、{{ $t("recruitment.project_manager.duties") }}
                </div>
                <div>
                  2、{{ $t("recruitment.project_manager.duties2") }}
                </div>
                <div>
                  3、{{ $t("recruitment.project_manager.duties3") }}
                </div>
                <div>
                  4、{{ $t("recruitment.project_manager.duties4") }}
                </div>
                <div>5、{{ $t("recruitment.project_manager.duties5") }}</div>
              </div>
              <div class="looking-right">
                <span>【{{ $t("recruitment.java_engineer.require") }}】</span>
                <div>
                  1、{{ $t("recruitment.project_manager.require_details") }}
                </div>
                <div>
                  2、{{ $t("recruitment.project_manager.require_details2") }}
                </div>
                <div>
                  3、{{ $t("recruitment.project_manager.require_details3") }}
                </div>
                <div>
                  4、{{ $t("recruitment.project_manager.require_details4") }}
                </div>
                <div>
                  5、{{ $t("recruitment.project_manager.require_details5") }}
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="internship()">
            <div class="you">
              <div class="looking-left">
                <span>【{{ $t("recruitment.java_engineer.jobs") }}】</span>
                <div>
                  1、{{ $t("recruitment.internship_work.duties") }}
                </div>
                <div>
                  2、{{ $t("recruitment.internship_work.duties2") }}
                </div>
                <div>
                  3、{{ $t("recruitment.internship_work.duties3") }}
                </div>
                <div>4、{{ $t("recruitment.internship_work.duties4") }}</div>
              </div>
              <div class="looking-right">
                <span>【{{ $t("recruitment.java_engineer.require") }}】</span>
                <div>1、{{ $t("recruitment.internship_work.require_details") }}</div>
                <div>2、{{ $t("recruitment.internship_work.require_details2") }}</div>
                <div>3、{{ $t("recruitment.internship_work.require_details3") }}</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="process">
      <h2 class="title">{{$t("recruitment.recruitment.title")}}</h2>
      <div class="procese-list">
        <div class="mail">
          <img src="../../assets/image/talent/mail.svg" alt="" />
          <div>{{$t("recruitment.recruitment.delivery")}}：hongpiao.mi@etao-it.com</div>
        </div>
        <div class="right">
          <img src="../../assets/image/talent/right.svg" alt="" />
        </div>
        <div class="phone">
          <img src="../../assets/image/talent/shouji.svg" alt="" />
          <div>{{$t("recruitment.recruitment.interview")}}</div>
        </div>
        <div class="right">
          <img src="../../assets/image/talent/right.svg" alt="" />
        </div>
        <div class="text">
          <img src="../../assets/image/talent/file-fill.svg" alt="" />
          <div>{{$t("recruitment.recruitment.offer")}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    java() {
      return this.$t("recruitment.java_engineer.java");
    },
    project() {
      return this.$t("recruitment.project_engineer.project");
    },
     product() {
      return this.$t("recruitment.product_manager.product");
    },
    assistant() {
      return this.$t("recruitment.product_assistant.assistant");
    },
     manager() {
      return this.$t("recruitment.project_manager.project");
    },
     internship() {
      return this.$t("recruitment.internship_work.internship");
    },
  },
  data() {
    return {
      activeName: "first",
    };
  },
};
</script>

<style scoped>
.talent {
  padding-top: 80px;
}
.bg > img {
  width: 100%;
  background-size: cover;
  background-size: 100% 100%;
}
.title {
  margin-top: 40px;
  text-align: center;
  font-size: 20px;
  color: #121212;
  line-height: 45px;
  position: relative;
}
h2:after {
  content: "";
  position: absolute;
  left: 49%;
  bottom: 0;
  height: 3px;
  width: 30px;
  background-color: red;
}
.looking-for {
  margin: 60px 180px;
  align-items: center;
}
.looking-for > div {
  margin-top: 50px;
}
.you {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: 40px;
  padding-bottom: 60px;
  color: #7e7e7c;
  font-size: 14px;
  line-height: 36px;
}
span {
  font-weight: 600;
  line-height: 60px;
  font-size: 18px;
  color: #ff0000;
}
.looking-left {
  width: 50%;
  margin-left: 30px;
  margin-right: 55px;
}
.looking-right {
  width: 50%;
  margin-left: 55px;
  margin-right: 30px;
}
.procese-list {
  display: flex;
  margin: 100px 150px;
  text-align: center;
  align-items: center;
  font-size: 14px;
  color: #7e7e7c;
  line-height: 30px;
  position: relative;
  font-size: 12px;
}
.mail  {
  width: 20%;
 
}
.phone {
  width: 20%;
}
.text {
  width: 20%;
  
}
.right {
  width: 20%;
}

</style>
<style>
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  color: #ff0000 !important   ;
}
.el-tabs--card > .el-tabs__header .el-tabs__item:hover {
  color: #ff0000 !important;
}
</style>